import React from "react";
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";

import Building from "../../Assets/Image/building.png";
import Customer from "../../Assets/Image/OurCustomers.png";
import Partner from "../../Assets/Image/OurPartners.png";
import Visi from "../../Assets/Image/Visi.png";
import Misi from "../../Assets/Image/Misi.png";
import ITCompany from "../../Assets/Image/IT company.jpg";

const companyValues = [
  {
    title: "Customer Focused",
    description:
      "We place customer objectives at the center of every solution, implementation, and support service.",
    icon: (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        className="h-7 w-7"
        aria-hidden="true"
      >
        <path
          d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM22 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    title: "Trusted Expertise",
    description:
      "Our experienced team combines technical competence, industry insight, and proven implementation practices.",
    icon: (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        className="h-7 w-7"
        aria-hidden="true"
      >
        <path
          d="m12 3 7 3v5c0 5-3.5 8.5-7 10-3.5-1.5-7-5-7-10V6l7-3Z"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="m9 12 2 2 4-4"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    title: "Integrated Solutions",
    description:
      "We deliver end-to-end IT solutions covering consultation, infrastructure, cybersecurity, and managed services.",
    icon: (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        className="h-7 w-7"
        aria-hidden="true"
      >
        <rect
          x="3"
          y="3"
          width="7"
          height="7"
          rx="2"
          stroke="currentColor"
          strokeWidth="1.8"
        />
        <rect
          x="14"
          y="3"
          width="7"
          height="7"
          rx="2"
          stroke="currentColor"
          strokeWidth="1.8"
        />
        <rect
          x="3"
          y="14"
          width="7"
          height="7"
          rx="2"
          stroke="currentColor"
          strokeWidth="1.8"
        />
        <rect
          x="14"
          y="14"
          width="7"
          height="7"
          rx="2"
          stroke="currentColor"
          strokeWidth="1.8"
        />
      </svg>
    ),
  },
];

const missions = [
  "Provide customers with efficient and reliable IT solutions from world-class technology principals.",
  "Develop the right strategy from planning and architecture through implementation and operational support.",
  "Create better, more effective, and sustainable business processes through technology.",
  "Deliver professional services supported by competent and experienced resources.",
  "Maintain a consistently high level of customer satisfaction.",
];

export default function About() {
  React.useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
      offset: 80,
    });
  }, []);

  return (
    <main className="overflow-hidden bg-white text-slate-900">
      {/* Hero */}
      <section className="px-4 pt-4 sm:px-6 lg:px-8">
        <div
          className="relative min-h-[620px] overflow-hidden rounded-[28px] bg-cover bg-center shadow-[0_30px_80px_rgba(15,44,72,0.22)] lg:min-h-[690px]"
          style={{ backgroundImage: `url(${Building})` }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-[#071C33]/95 via-[#123A60]/88 to-[#123A60]/35" />
          <div className="absolute -right-28 top-16 h-80 w-80 rounded-full bg-[#2392D0]/20 blur-3xl" />
          <div className="absolute -bottom-36 left-1/3 h-96 w-96 rounded-full bg-white/10 blur-3xl" />

          <div className="relative z-10 mx-auto flex min-h-[620px] max-w-7xl items-center px-6 py-24 sm:px-10 lg:min-h-[690px] lg:px-16">
            <div className="max-w-3xl" data-aos="fade-up">
              <div className="mb-6 inline-flex items-center gap-3 rounded-full border border-white/20 bg-white/10 px-4 py-2 backdrop-blur-md">
                <span className="h-2.5 w-2.5 rounded-full bg-[#42B6F5]" />
                <span className="text-sm font-semibold uppercase tracking-[0.18em] text-white/90">
                  About Viktorindo
                </span>
              </div>

              <h1 className="max-w-3xl text-4xl font-semibold leading-tight text-white sm:text-5xl lg:text-7xl">
                Technology expertise built for
                <span className="block text-[#58BFF4]">business progress.</span>
              </h1>

              <p className="mt-7 max-w-2xl text-base leading-8 text-slate-200 sm:text-lg">
                PT Viktorindo Teknologi Prima helps organizations design,
                implement, secure, and operate modern information technology
                environments through trusted expertise and strategic
                partnerships.
              </p>

              <div className="mt-10 flex flex-col gap-4 sm:flex-row">
                <Link
                  to="/services"
                  className="inline-flex items-center justify-center gap-3 rounded-full bg-[#2392D0] px-7 py-3.5 text-sm font-semibold text-white shadow-lg shadow-[#2392D0]/25 transition duration-300 hover:-translate-y-1 hover:bg-[#1D82BB]"
                >
                  Explore Our Services
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    className="h-5 w-5"
                    aria-hidden="true"
                  >
                    <path
                      d="M5 12h14M13 6l6 6-6 6"
                      stroke="currentColor"
                      strokeWidth="1.8"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </Link>

                <a
                  href="#company-profile"
                  className="inline-flex items-center justify-center rounded-full border border-white/30 bg-white/10 px-7 py-3.5 text-sm font-semibold text-white backdrop-blur-md transition duration-300 hover:bg-white hover:text-[#123A60]"
                >
                  Discover Our Company
                </a>
              </div>
            </div>
          </div>

          <div className="absolute bottom-0 right-0 hidden rounded-tl-[40px] border-l border-t border-white/15 bg-white/10 px-10 py-8 backdrop-blur-xl lg:block">
            <p className="text-xs font-semibold uppercase tracking-[0.18em] text-white/60">
              Our Commitment
            </p>
            <p className="mt-2 max-w-xs text-lg font-medium leading-7 text-white">
              Delivering dependable technology solutions with measurable
              business value.
            </p>
          </div>
        </div>
      </section>

      {/* Company profile */}
      <section
        id="company-profile"
        className="mx-auto max-w-7xl px-5 py-24 sm:px-6 lg:px-8 lg:py-32"
      >
        <div className="grid items-center gap-14 lg:grid-cols-[1.05fr_0.95fr] lg:gap-20">
          <div data-aos="fade-right">
            <div className="mb-6 inline-flex items-center gap-3 text-sm font-bold uppercase tracking-[0.2em] text-[#2392D0]">
              <span className="h-px w-10 bg-[#2392D0]" />
              Who We Are
            </div>

            <h2 className="max-w-2xl text-3xl font-semibold leading-tight text-[#123A60] sm:text-4xl lg:text-5xl">
              A trusted IT solution partner for complex business challenges.
            </h2>

            <p className="mt-7 text-base leading-8 text-slate-600 sm:text-lg">
              We are an experienced IT solutions company providing complete
              information technology services, from consultation and enterprise
              architecture to implementation, migration planning, change
              management, cybersecurity, and operational support.
            </p>

            <p className="mt-5 text-base leading-8 text-slate-600 sm:text-lg">
              Supported by competent professionals and world-class technology
              principals, we deliver integrated strategic solutions that help
              organizations improve business processes, strengthen resilience,
              and prepare for future growth.
            </p>

            <div className="mt-9 grid gap-4 sm:grid-cols-2">
              <div className="rounded-2xl border border-slate-200 bg-slate-50 p-5">
                <p className="text-3xl font-semibold text-[#2392D0]">End-to-End</p>
                <p className="mt-2 text-sm leading-6 text-slate-600">
                  From strategy and design through implementation and support.
                </p>
              </div>
              <div className="rounded-2xl border border-slate-200 bg-slate-50 p-5">
                <p className="text-3xl font-semibold text-[#2392D0]">Enterprise</p>
                <p className="mt-2 text-sm leading-6 text-slate-600">
                  Solutions designed for reliability, security, and scalability.
                </p>
              </div>
            </div>
          </div>

          <div className="relative" data-aos="fade-left">
            <div className="absolute -left-6 -top-6 hidden h-32 w-32 rounded-3xl border border-[#2392D0]/25 lg:block" />
            <div className="relative overflow-hidden rounded-[30px] shadow-[0_25px_70px_rgba(18,58,96,0.20)]">
              <img
                src={ITCompany}
                alt="Viktorindo Teknologi Prima IT solutions team"
                className="h-[520px] w-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#071C33]/75 via-transparent to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-7 sm:p-9">
                <p className="text-sm font-semibold uppercase tracking-[0.18em] text-[#58BFF4]">
                  Strategic Technology Partner
                </p>
                <p className="mt-3 max-w-md text-xl font-semibold leading-8 text-white sm:text-2xl">
                  Turning technology investment into sustainable business
                  capability.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="bg-[#F4F8FC] py-24 lg:py-28">
        <div className="mx-auto max-w-7xl px-5 sm:px-6 lg:px-8">
          <div className="max-w-3xl" data-aos="fade-up">
            <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#2392D0]">
              How We Work
            </p>
            <h2 className="mt-4 text-3xl font-semibold leading-tight text-[#123A60] sm:text-4xl lg:text-5xl">
              Built around trust, expertise, and practical execution.
            </h2>
          </div>

          <div className="mt-14 grid gap-6 md:grid-cols-3">
            {companyValues.map((item, index) => (
              <article
                key={item.title}
                className="group rounded-[24px] border border-slate-200 bg-white p-7 shadow-sm transition duration-300 hover:-translate-y-2 hover:shadow-[0_24px_60px_rgba(18,58,96,0.14)]"
                data-aos="fade-up"
                data-aos-delay={index * 100}
              >
                <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-[#E8F5FC] text-[#2392D0] transition duration-300 group-hover:bg-[#2392D0] group-hover:text-white">
                  {item.icon}
                </div>
                <h3 className="mt-6 text-xl font-semibold text-[#123A60]">
                  {item.title}
                </h3>
                <p className="mt-4 leading-7 text-slate-600">
                  {item.description}
                </p>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Vision & Mission */}
      <section className="px-4 py-24 sm:px-6 lg:px-8 lg:py-32">
        <div className="relative mx-auto max-w-7xl overflow-hidden rounded-[32px] bg-[#123A60] px-6 py-16 shadow-[0_30px_80px_rgba(18,58,96,0.24)] sm:px-10 lg:px-16 lg:py-20">
          <div className="absolute -right-24 -top-24 h-80 w-80 rounded-full bg-[#2392D0]/25 blur-3xl" />
          <div className="absolute -bottom-40 left-20 h-96 w-96 rounded-full bg-white/5 blur-3xl" />

          <div className="relative z-10 text-center" data-aos="fade-up">
            <p className="text-sm font-bold uppercase tracking-[0.22em] text-[#58BFF4]">
              Vision & Mission
            </p>
            <h2 className="mx-auto mt-4 max-w-3xl text-3xl font-semibold leading-tight text-white sm:text-4xl lg:text-5xl">
              A clear direction for delivering lasting technology value.
            </h2>
          </div>

          <div className="relative z-10 mt-14 grid gap-7 lg:grid-cols-2">
            <article
              className="rounded-[26px] border border-white/15 bg-white/10 p-7 backdrop-blur-md sm:p-9"
              data-aos="fade-right"
            >
              <div className="flex flex-col gap-6 sm:flex-row sm:items-center">
                <div className="flex h-24 w-24 flex-shrink-0 items-center justify-center rounded-3xl bg-white p-4">
                  <img
                    src={Visi}
                    alt="Viktorindo company vision"
                    className="h-full w-full object-contain"
                  />
                </div>
                <div>
                  <p className="text-sm font-bold uppercase tracking-[0.18em] text-[#58BFF4]">
                    Our Vision
                  </p>
                  <h3 className="mt-2 text-2xl font-semibold text-white">
                    Excellence in technology service.
                  </h3>
                </div>
              </div>
              <blockquote className="mt-7 border-l-2 border-[#58BFF4] pl-5 text-lg leading-8 text-slate-200">
                “To be one of the best information technology providers with
                the most excellent service.”
              </blockquote>
            </article>

            <article
              className="rounded-[26px] border border-white/15 bg-white/10 p-7 backdrop-blur-md sm:p-9"
              data-aos="fade-left"
            >
              <div className="flex flex-col gap-6 sm:flex-row sm:items-center">
                <div className="flex h-24 w-24 flex-shrink-0 items-center justify-center rounded-3xl bg-white p-4">
                  <img
                    src={Misi}
                    alt="Viktorindo company mission"
                    className="h-full w-full object-contain"
                  />
                </div>
                <div>
                  <p className="text-sm font-bold uppercase tracking-[0.18em] text-[#58BFF4]">
                    Our Mission
                  </p>
                  <h3 className="mt-2 text-2xl font-semibold text-white">
                    Delivering meaningful business outcomes.
                  </h3>
                </div>
              </div>

              <ul className="mt-7 space-y-4">
                {missions.map((mission) => (
                  <li
                    key={mission}
                    className="flex gap-3 text-sm leading-7 text-slate-200 sm:text-base"
                  >
                    <span className="mt-1.5 flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full bg-[#2392D0]">
                      <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        className="h-3.5 w-3.5"
                        aria-hidden="true"
                      >
                        <path
                          d="m7 12 3 3 7-7"
                          stroke="white"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </span>
                    <span>{mission}</span>
                  </li>
                ))}
              </ul>
            </article>
          </div>
        </div>
      </section>

      {/* Partners */}
      <section className="bg-[#F4F8FC] py-24 lg:py-28">
        <div className="mx-auto max-w-7xl px-5 sm:px-6 lg:px-8">
          <div className="grid items-center gap-10 lg:grid-cols-[0.7fr_1.3fr] lg:gap-16">
            <div data-aos="fade-right">
              <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#2392D0]">
                Technology Ecosystem
              </p>
              <h2 className="mt-4 text-3xl font-semibold leading-tight text-[#123A60] sm:text-4xl">
                Supported by trusted global technology partners.
              </h2>
              <p className="mt-5 leading-8 text-slate-600">
                Our partnerships allow us to combine proven technologies with
                local expertise, implementation capability, and ongoing
                customer support.
              </p>
              <Link
                to="/products"
                className="mt-8 inline-flex items-center gap-3 font-semibold text-[#2173AA] transition hover:gap-4"
              >
                View Technology Products
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  className="h-5 w-5"
                  aria-hidden="true"
                >
                  <path
                    d="M5 12h14M13 6l6 6-6 6"
                    stroke="currentColor"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </Link>
            </div>

            <div
              className="overflow-hidden rounded-[28px] border border-slate-200 bg-white p-5 shadow-[0_20px_60px_rgba(18,58,96,0.10)] sm:p-8"
              data-aos="fade-left"
            >
              <img
                src={Partner}
                alt="Viktorindo technology partners"
                className="h-auto w-full object-contain"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Customers */}
      <section className="mx-auto max-w-7xl px-5 py-24 sm:px-6 lg:px-8 lg:py-32">
        <div className="mx-auto max-w-3xl text-center" data-aos="fade-up">
          <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#2392D0]">
            Trusted by Organizations
          </p>
          <h2 className="mt-4 text-3xl font-semibold leading-tight text-[#123A60] sm:text-4xl lg:text-5xl">
            Long-term relationships built through dependable delivery.
          </h2>
          <p className="mt-6 leading-8 text-slate-600">
            We support customers across different sectors with technology
            solutions designed around operational needs, security, and
            continuous improvement.
          </p>
        </div>

        <div
          className="mt-14 overflow-hidden rounded-[28px] border border-slate-200 bg-white p-5 shadow-[0_20px_60px_rgba(18,58,96,0.10)] sm:p-8 lg:p-10"
          data-aos="fade-up"
        >
          <img
            src={Customer}
            alt="Viktorindo customers"
            className="h-auto w-full object-contain"
          />
        </div>
      </section>

      {/* CTA */}
      <section className="px-4 pb-24 sm:px-6 lg:px-8 lg:pb-32">
        <div className="relative mx-auto max-w-7xl overflow-hidden rounded-[30px] bg-gradient-to-r from-[#123A60] to-[#2173AA] px-6 py-14 sm:px-10 lg:flex lg:items-center lg:justify-between lg:px-14">
          <div className="absolute -right-12 -top-24 h-72 w-72 rounded-full border border-white/10" />
          <div className="absolute -right-4 -top-14 h-52 w-52 rounded-full border border-white/10" />

          <div className="relative z-10 max-w-2xl">
            <p className="text-sm font-bold uppercase tracking-[0.18em] text-[#78CDF8]">
              Let&apos;s Build What&apos;s Next
            </p>
            <h2 className="mt-3 text-3xl font-semibold leading-tight text-white sm:text-4xl">
              Need a reliable partner for your next IT initiative?
            </h2>
            <p className="mt-4 leading-7 text-slate-200">
              Talk with our team about infrastructure, cybersecurity,
              application, integration, or managed service requirements.
            </p>
          </div>

          <div className="relative z-10 mt-8 lg:mt-0">
            <Link
              to="/#contact"
              className="inline-flex items-center justify-center gap-3 rounded-full bg-white px-7 py-3.5 text-sm font-semibold text-[#123A60] transition duration-300 hover:-translate-y-1 hover:shadow-xl"
            >
              Contact Our Team
              <svg
                viewBox="0 0 24 24"
                fill="none"
                className="h-5 w-5"
                aria-hidden="true"
              >
                <path
                  d="M5 12h14M13 6l6 6-6 6"
                  stroke="currentColor"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
}